<script>

	import * as tf from '@tensorflow/tfjs';
	import * as blazeface from '@tensorflow-models/blazeface';
	import {Col, Container, Row} from 'sveltestrap';
	import {onMount} from 'svelte';

	let expW = 256;
	let expH = 256;

	let globalStream;
	let video;
	let model;
	let maskModel;
	// let path_to_mask_model = './models/mask_clf/model.json';
	// let path_to_mask_model = './models/pret/model.json';
	let path_to_mask_model = 'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/mask_detector/model.json';

	async function setupWebcam() {
        video = document.getElementById('video');
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({ video: {width: expW, height: expH} }).then(function(stream) {
                video.srcObject = stream;
                video.play();
                globalStream = stream;
            });
        }

    }
	async function toggleWebcam() {
		if (videoOn) {
			clearInterval(currentTimer)
			globalStream.getTracks().forEach(track => track.stop());
		} else {
			await setupWebcam();
			snap();
		}
		videoOn = !videoOn;
	}

	let currentTimer;
	async function snap() {
		let imgOutput = document.getElementById('img-output');
		let vid = document.getElementById('video');
        var canvas = document.createElement('canvas');

		currentTimer = setInterval(async () => {
		// currentTimer = setTimeout(async () => {
			if (vid.readyState === 4) {
				canvas.width = vid.videoWidth;
				canvas.height = vid.videoHeight;
				let context = canvas.getContext("2d");
				context.drawImage(vid, 0, 0, vid.videoWidth, vid.videoHeight);
				let content = tf.tidy(() => {
					let content = tf.browser
									.fromPixels(document.getElementById('video'))
									.reverse(-1);
					content = cropResize(content);
					tf.browser.toPixels(tf.div(content.reshape([256, 256, 3]), 255).reverse(-1), canvas);
					return content;

				})
				let returnTensors = false;
				let predictions = await model.estimateFaces(content, returnTensors);

				if (!returnTensors) {
					for (let i=0; i<predictions.length; i++) {
						const start = predictions[i].topLeft;
						const end = predictions[i].bottomRight;
						const size = [end[0] - start[0], end[1] - start[1]];

						let p = tf.tidy(() => {
							let patch = tf.slice(
								content,
								[Math.round(start[0]), Math.round(start[1])],
								[Math.round(size[0]), Math.round(size[1])],
							);
							// console.log(patch.shape);
							let patchRs = tf.image.resizeBilinear(
								tf.expandDims(patch),
								[224, 224]
							);

							patchRs = tf.sub(tf.mul(tf.div(patchRs, 255), 2), 1);
							let preds = maskModel.predict(patchRs);
							let p = preds.dataSync()[0];
							return p;

						})
						content.dispose();


						p = p*p;
						
						context.lineWidth = 5;
						if (p < 0.5) {
							context.strokeStyle = 'red';
							context.fillStyle = 'red';
						} else {
							context.strokeStyle = 'green';
							context.fillStyle = 'green';
						}
						context.font = 'bold 22px Arial';
						context.fillText(p.toFixed(3), start[0] + 5, start[1] - 10);
						context.strokeRect(start[0], start[1], size[0], size[1]);
					}
					let dataURL = canvas.toDataURL('image/jpeg');
					imgOutput.src = dataURL;
				}
				}
			},
			200,
		)
	}
	function cropResize(imgTensor) {
		let originalH = imgTensor.shape[0];
        let originalW = imgTensor.shape[1];
        let maxSize = Math.max(originalH, originalW);
        let hPad = (maxSize - originalH) / 2;
        let wPad = (maxSize - originalW) / 2;
        let paddedTensor = tf.pad(imgTensor, [[hPad, hPad], [wPad, wPad], [0, 0]]);
        paddedTensor = tf.image.resizeBilinear(paddedTensor, [256, 256]);
        imgTensor.dispose();
        return paddedTensor;
	}

	let videoOn;

	onMount(async() => {
		model = await blazeface.load();
		// console.log(model);
		maskModel = await tf.loadLayersModel(path_to_mask_model);
		// console.log(maskModel);
		// toggleWebcam();
		videoOn = false;
	});
</script>

<div id="video-container">
	<!-- svelte-ignore a11y-media-has-caption -->
	<video id="video" width={expW} height={expH}></video>
</div>

<Container>
	<Row>
		<!-- <Col xs="4"></Col> -->
		<Col>
			<div id='detector-col'>
				<button on:click={toggleWebcam} >
					{#if videoOn}
						Stop
					{:else}
						Start
					{/if}
				</button>
				<img
					id="img-output"
					alt=""
					/>
			</div>
		</Col>
		<!-- <Col xs="4"></Col> -->
</Row>
</Container>

<style>
	#video-container {
		display: none;
	}
	button {
		display: inline-block;
		padding: 10px;
		padding-right: 30px;
		padding-left: 30px;
		margin: 1px;
		align-self: center;
	}
	#detector-col {
		margin-top: 40px;
		margin-bottom: 10px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-items: center;
	}
	#img-output {
		align-self: center;
	}
</style>